import { BaseModel } from "./base";
import { UserMinumum } from "./user";

export class Label extends BaseModel{
  account?: any;
  deleted: boolean;
  sequence: number=0;
  name: string=null;
  color: string=null;
  createdBy: UserMinumum;
  updatedBy: UserMinumum;
 }
